import { render, staticRenderFns } from "./SimpleGallery.vue?vue&type=template&id=42c5df90&scoped=true&"
import script from "./SimpleGallery.vue?vue&type=script&lang=js&"
export * from "./SimpleGallery.vue?vue&type=script&lang=js&"
import style0 from "./SimpleGallery.vue?vue&type=style&index=0&id=42c5df90&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c5df90",
  null
  
)

export default component.exports